import React, { ChangeEvent } from 'react';
import { OpenComponent } from '../../../enums/misc.enum';
import { IPaginationMeta } from '../../../type/admin.types';
import { BasicMIDs } from '../../../type/mids.types';
import StatusText from '../../admin-table/components/status-text.component';
import XSkeletonLoadingTableBody from '../../x-components/x-skeletons/x-skeleton-loading-table.component';
import XSafeTextInfo from '../../x-components/x-safe-text-info.component';
import XThead from '../../x-components/x-table-header.component';
import XTable from '../../x-components/x-table/x-table.component';

function MIDsTable(props: Props) {
  const {
    mids,
    setComponentManager,
    setSelectedMIDId,
    isLoading,
    checkedAll,
    setCheckedAll,
    isChecked,
    setIsChecked,
    isViewOnly,
  } = props;
  const navigateToMID = (id: number) => {
    setComponentManager(OpenComponent.VIEW_USER);
    setSelectedMIDId(id);
  };

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;

    if (checked) {
      setIsChecked([...isChecked, Number(id)]);
    } else {
      setIsChecked(isChecked.filter((item) => item !== Number(id)));
    }
  };

  const handleCheckAll = () => {
    if (!mids) {
      return;
    }
    let arr = mids;
    setCheckedAll(!checkedAll);

    if (checkedAll) {
      setIsChecked([]);
    } else {
      setIsChecked(arr.map((li) => li.midId));
    }
  };

  return (
    <XTable>
      <XThead>
        <tr>
          {!isViewOnly && (
            <th style={{ width: 30 }}>
              <input
                type='checkbox'
                style={{ cursor: 'pointer' }}
                onChange={handleCheckAll}
                checked={checkedAll}
              />
            </th>
          )}
          <th>MID name</th>
          <th>Switch name</th>
          <th>Card type</th>
          <th>Status</th>
        </tr>
      </XThead>
      {isLoading ? (
        <XSkeletonLoadingTableBody numColumns={!isViewOnly ? 5 : 4} />
      ) : (
        <tbody>
          {mids?.map((mid) => (
            <tr key={mid.midId}>
              {!isViewOnly && (
                <td>
                  <input
                    type='checkbox'
                    style={{ cursor: 'pointer' }}
                    id={mid.midId.toString()}
                    checked={isChecked.includes(mid.midId)}
                    onChange={handleCheck}
                  />
                </td>
              )}
              <td onClick={() => navigateToMID(mid.midId)}>
                <XSafeTextInfo data={mid.midName} />
              </td>
              <td onClick={() => navigateToMID(mid.midId)}>
                <XSafeTextInfo data={mid.switchName} />
              </td>
              <td onClick={() => navigateToMID(mid.midId)}>
                <XSafeTextInfo data={mid.cardType} />
              </td>
              <td onClick={() => navigateToMID(mid.midId)}>
                <StatusText status={mid.isActive ? 'ENABLED' : 'DISABLED'} />
              </td>
            </tr>
          ))}
        </tbody>
      )}
    </XTable>
  );
}

export default MIDsTable;

interface Props {
  mids: BasicMIDs[] | undefined;
  setComponentManager: React.Dispatch<React.SetStateAction<OpenComponent>>;
  setSelectedMIDId: React.Dispatch<React.SetStateAction<number | undefined>>;
  isLoading: boolean;
  checkedAll: boolean;
  setCheckedAll: React.Dispatch<React.SetStateAction<boolean>>;
  isChecked: number[];
  setIsChecked: React.Dispatch<React.SetStateAction<number[]>>;
  isViewOnly: boolean;
}
